module.exports = __webpack_public_path__ + "img/ic_introduce_bottom_right_img.9f410263.png";